import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';
import waitImg from '../img/wait.png'
import WaitIcon from '@material-ui/icons/Timer';

export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, #a1a1a1, royalblue)', color:'white', padding:'5px', borderRadius:'20px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'

  }


    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img draggable={false} src={waitImg} width='50' height='50'></img> */}

      <WaitIcon fontSize='medium' style={designerIconStyle} draggable={false}/>
      {/* <h4>{data.label}  </h4>  */}
      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});